import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../stores/store';
import ListLayout from '../../../Generic/ListLayout';
import DataTable from '../../../Generic/DataTable';
import confirmDeleteDialog from '../../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../../hooks/useDeleteItem';
import useFilterData from '../../../../hooks/useFilterData';
import useFetchData from '../../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../../hooks/useSetMenu";
import { createGeneralColumn, createActiveColumn, createActionColumn } from '../../../Generic/dataGridColumns';

const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { mainStore, researchPublicationStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.ResearchPublicationsAdminMenuType, mainStore.ResearchPublicationsAdminMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  useFetchData(axiosPrivate, `/ResearchPublications`, researchPublicationStore);
  const filteredData = useFilterData(toJS(researchPublicationStore.researchPublications), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const deleteItem = useDeleteItem(axiosPrivate, '/ResearchPublications', researchPublicationStore.deleteItem);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deleteItem, id);
  }, [deleteItem, t]);

  const cols = useMemo(() => [
    createGeneralColumn("year", "year", t, 80),
    createGeneralColumn("title", "title", t, 200),
    createGeneralColumn("category", "category", t, 120),
    createGeneralColumn("venue", "venue", t, 150),
    createActiveColumn(t),
    createActionColumn(t, "/Admin/ResearchPublications/Edit", remove),
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("researchPublicationsListTitle") || "Research Publications"}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/Admin/ResearchPublications/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);
